import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  meteringHistoryContainer: {
    display: 'flex',
    marginBottom: theme.spacing(3),
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  meteringHistoryInnerContainer: {
    display: 'flex',
    color: theme.palette.select.light,
    justifyContent: 'flex-end',
    width: 'fit-content',
    alignItems: 'center',
    cursor: 'pointer',
  },
  meteringHeading: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '14px',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '20px',
    letterSpacing: '0.1px',
    marginLeft: theme.spacing(0.5),
  },
  root: {
    display: 'flex',
    marginBottom: theme.spacing(11),
  },
  contractsContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gridGap: theme.spacing(4, 3),
    textAlign: 'left',
    width: '100%',
    ['@media (max-width:1500px)']: {
      gridTemplateColumns: '1fr',
    },
  },
  contract: {
    backgroundColor: theme.palette.bg.main,
  },
  loaderRootContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: theme.spacing(11),
  },
  logoImg: {
    pointerEvents: 'none',
    height: theme.spacing(6),
    width: theme.spacing(6),
  },
  loaderHeader: {
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '28px',
    color: theme.palette.labraText.tertiary,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'center',
    marginTop: theme.spacing(3),
  },
  loaderSubHeader: {
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'center',
    marginTop: theme.spacing(1),
  },
  loadingSpinner: {
    color: theme.palette.labraFormProgress.main,
    width: '31px',
    height: '31px',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(11),
  },
  needMeteringHelp: {
    marginBottom: theme.spacing(2),
    width: 'max-content',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
}))
